
<div style="display: flex;justify-content: center;" >
  <mat-card style="width: max-content">
    <mat-card-header
      style="justify-content: center; background-color: ghostwhite"
    >
      <mat-card-title>
        <span>
          <img
            alt="Logo"
            src="assets/images/TLS_Logo.png"
            style="height: 32px; margin-top: 9px; float: center"
          />
        </span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content style="margin-top: 3%; margin-bottom: 1%">
      <div>
        <div *ngIf="errorMessage" style="display: flex;
        justify-content: center;
        margin: 3%;">
          {{ errorMessage }}
        </div>
        <form [formGroup]="loginForm" (ngSubmit)="resetPassword(loginForm.value)">
          <mat-form-field
            appearance="outline"
            style="width: 500px; margin-bottom: 10px"
          >
            <input
              matInput
              formControlName="password"
              type="{{ passwordType }}"
              placeholder="Password"
            />
            <mat-icon matPrefix style="border-right: groove; margin-right: 20px;margin-left: 10px;"
              >vpn_key</mat-icon
            >
                <mat-icon matSuffix style="cursor: pointer; color: grey;margin-right: 10px;" (click)="setPasswordType()"
                  >{{passwordType === 'password' ? 'visibility' : 'visibility_off'}}</mat-icon
                >
            <mat-error *ngIf="loginForm.controls.password.errors?.required">
              Required
            </mat-error>
          </mat-form-field>
          <br />

          <mat-form-field
          appearance="outline"
          style="width: 500px; margin-bottom: 10px"
        >
          <input matInput formControlName="confirmpassword" type = "password" placeholder="Confirm Password" />
          <mat-icon matPrefix style="border-right: groove; margin-right: 20px;margin-left: 10px;"
            >vpn_key</mat-icon
          >
          <mat-error *ngIf="loginForm.controls.confirmpassword.errors?.required">
            Required
          </mat-error> </mat-form-field
        >
        <!-- <div> Valid: {{ loginForm.valid ? "Password match" : 'Password does not match' }} </div> -->
        <div *ngIf="(loginForm.touched || loginForm.dirty)" class="cross-validation-error-message alert alert-danger">
          {{ loginForm.valid ? "Password matched" : 'Password does not match' }}
          </div>
          <div style="display: flex; justify-content: center">
            <button
              type="submit"
              mat-raised-button
              style="background-color: steelblue; color: white"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <hr>

    </mat-card-content>
  </mat-card>
  </div>

